// extracted by mini-css-extract-plugin
export default {"container":"YandexProjectLogo_container__6PTi9","text":"YandexProjectLogo_text__9nNOv","logo":"YandexProjectLogo_logo__ii0gM"};